module.exports = __webpack_public_path__ + "static/media/Costa_Duarte.487a725d.png";